import React, { useState, useEffect } from "react";
import PathakSirImage from "../Images/DNPathak.webp";
import AOS from "aos";
import "aos/dist/aos.css";

const testimonials = [
  {
    initials: "VP",
    name: "Vikas Pandey",
    role: "Senior Manager – Internal Control & Traceability Ploughman Agro Private Limited (PAPL)",
    message:
      "GeeCom India’s Organic Digital Documentation solution has brought a remarkable shift in how we manage our traceability and certification processes. Their deep understanding of both technical systems and the organic agriculture field made the collaboration seamless and impactful. The platform helped us move away from time-consuming paperwork and introduced a structured, transparent, and digitally traceable system. It has not only increased the accuracy of our field-level data but also made compliance reporting much more efficient. The solution is both practical and farmer-friendly – a true asset for any organization working in the organic space.",
    rating: 5,
    date: "2 months ago",
  },
  {
    initials: "YS",
    name: "Yashwant Suthar",
    role: "Founder, Lootel",
    message:
      "At Lootel, we are committed to providing clean, hygienic, and safe smart restrooms across India. To ensure our operations run smoothly, we partnered with GeeCom India to develop a comprehensive software solution for our staff training, attendance, and internal record management. The tailored system has significantly improved our internal processes, offering real-time tracking and streamlined workflows. GeeCom India's expertise in understanding our unique requirements and delivering a user-friendly platform has been instrumental in enhancing our operational efficiency. We appreciate their dedication to providing solutions that align with our mission of transforming public sanitation. GeeCom India's support has been invaluable in helping us maintain high standards and continue our growth.",
    rating: 5,
    date: "1 month ago",
  },

  {
    initials: "ST",
    name: "Sidharth",
    role: "IIT Guwahati & CDPO Team",
    message:
      "We are truly grateful to GeeCom India for providing us with an excellent digital tool to conduct the AWS and CDPO Surveys in Assamese. The platform was easy to navigate and made the entire data collection process smooth and efficient. It allowed us to manage responses in real-time and analyze the results effortlessly. This significantly helped us in drawing valuable insights for our planning and decision-making. The support from the GeeCom India team was prompt and reliable throughout the project. We look forward to working together on future initiatives.",
    rating: 5,
    date: "2 months ago",
  },
];
const testimonialsdata = [
  {
    initials: "PK",
    name: "Pradeep Kumar",
    role: "Vegetable Farmer, Bihar",
    message:
      "No more wastage! Using GeeCom's demand mapping, I know exactly how much to harvest and where to sell.",
  },
  {
    initials: "AN",
    name: "Arun Nair",
    role: "Hariom Seeds Team",
    message:
      "The digital documentation feature has simplified our CSR reporting process immensely. Highly recommended!",
  },
  {
    initials: "KS",
    name: "Kiran Singh",
    role: "ASRLM Team (SuATI Project)",
    message:
      "Managing milk collection records digitally has eliminated errors and improved our efficiency dramatically.",
  },
  {
    initials: "LM",
    name: "Lakshmi Menon",
    role: "IIT Guwahati & CDPO Team",
    message:
      "Our women's group can now take orders directly from customers. Digital inclusion at its best!",
  },
  {
    initials: "MR",
    name: "Vinod Patel",
    role: "Agricultural Input Retailer, Gujarat",

    message:
      "I've expanded my customer base by 50% since using GeeCom's digital marketing tools. Impressive!",
  },
];
const testimonialsPopup = [
  {
    name: "Sunita Rao",
    role: "Vegetable Seller",
    initials: "SR",
    videoUrl: "https://www.youtube.com/shorts/S9MrGIjOy3U",
  },
  {
    name: "Ajay Bhatt",
    role: "FPO Manager",
    initials: "AB",
    videoUrl: "https://www.youtube.com/shorts/qH_Z6SXzrC0",
  },
  {
    name: "Priya Joshi",
    role: "Handicraft Artisan",
    initials: "PJ",
    videoUrl: "https://www.youtube.com/shorts/Itm-DcaQpeA",
  },
  {
    name: "Ravi Gupta",
    role: "Organic Certifier",
    initials: "RG",
    videoUrl: "https://www.youtube.com/shorts/y1Mc0keZg-U",
  },
];

const getYouTubeVideoId = (url) => {
  const match = url.match(
    /(?:v=|\/embed\/|youtu\.be\/|\/shorts\/)([a-zA-Z0-9_-]{11})/
  );
  return match ? match[1] : null;
};

const StarRating = ({ count }) => {
  return (
    <div className="flex space-x-1">
      {[...Array(count)].map((_, index) => (
        <svg
          key={index}
          className="w-4 h-4 text-yellow-500"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 
          3.292a1 1 0 00.95.69h3.462c.969 0 1.371 
          1.24.588 1.81l-2.8 2.034a1 1 0 
          00-.364 1.118l1.07 3.292c.3.921-.755 
          1.688-1.54 1.118l-2.8-2.034a1 1 0 
          00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-
          1.539-1.118l1.07-3.292a1 1 0 00-.364-
          1.118L2.98 8.72c-.783-.57-.38-1.81.588-
          1.81h3.461a1 1 0 00.951-.69l1.07-
          3.292z"
          />
        </svg>
      ))}
    </div>
  );
};

const Testimonials = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(testimonialsPopup[0]);
  const [paused, setPaused] = useState(false);

  const handlePause = () => setPaused(true);
  const handleResume = () => setPaused(false);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <section id="testimonials" className="bg-gray-50" data-aos="fade-up">
        <div className="container mx-auto px-4" id="el-gzt5bpyl">
          {/* Customer Testimonial Section */}
          <div className="text-center">
            <h3
              className="text-2xl font-bold text-gray-900 mb-12"
              id="el-zw8syz2l"
              data-aos="zoom-in"
            >
              What Our Mentor Says
            </h3>

            <div
              className="relative py-10 px-6 bg-gradient-to-br from-blue-50 to-white rounded-2xl"
              id="el-ea7j7lat"
              data-aos="fade-up"
            >
              <svg
                className="absolute top-6 left-6 h-16 w-16 text-blue-100"
                fill="currentColor"
                viewBox="0 0 32 32"
                aria-hidden="true"
                id="el-6sk27jmj"
              >
                <path
                  d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                  id="el-867ny2ws"
                />
              </svg>

              <div
                className="relative max-w-2xl mx-auto text-center"
                id="el-ofzpn1ng"
              >
                <blockquote id="el-483xnejp">
                  <p
                    className="text-xl font-medium text-gray-900 mb-8"
                    id="el-9fmcf622"
                  >
                    "GeeCom India is bringing much-needed digital transformation
                    to the organic farming community. Their simple and scalable
                    tools help organic farmers and FPOs manage documentation,
                    traceability, and certification with ease. This kind of
                    farmer-friendly innovation is essential to building trust,
                    transparency, and market access in the organic sector. I am
                    proud to mentor a platform that is empowering Bharat’s
                    organic movement through technology."
                  </p>
                  <cite className="inline-flex items-center" id="el-4vrttyg9">
                    <span
                      className="relative h-14 w-14 rounded-full bg-blue-100 flex items-center justify-center mr-3"
                      id="el-h4qhbhhs"
                    >
                      <span
                        className="text-blue-600 text-xl font-bold"
                        id="el-posyljxx"
                      >
                        MG
                      </span>
                    </span>
                    <span className="text-left" id="el-tjm1xooq">
                      <span
                        className="font-medium text-gray-900 block"
                        id="el-q0njb1e9"
                      >
                        Mukesh Gupta
                      </span>
                      <span className="text-gray-600 text-sm" id="el-ndbdjaea">
                        Organic Industry Leader & Mentor at GeeCom India Chief
                        Editor, HelloKisan.org .
                      </span>
                    </span>
                  </cite>
                </blockquote>
              </div>
            </div>
          </div>

          {/* Bottom CTA */}
          <div className="mt-20 text-center" id="el-xio87t09">
            <h3
              className="text-2xl font-bold text-gray-900 mb-4"
              id="el-4epk24ca"
            >
              Ready to Experience the Benefits?
            </h3>
            <p
              className="text-lg text-gray-600 max-w-2xl mx-auto mb-8"
              id="el-2u4f96fp"
            >
              Join thousands of satisfied rural entrepreneurs who've transformed
              their business with GeeCom's digital solutions.
            </p>
            <a
              href="#contact"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-md font-medium text-lg transition-colors duration-300 mb-4"
              id="el-a6jetztc"
            >
              Get Started Today
            </a>
          </div>
        </div>
      </section>
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4" id="el-cnypi0v1">
          {/* Section Header */}
          <div
            className="text-center mb-16"
            id="el-u2lymyof"
            data-aos="fade-right"
          >
            <h2
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
              id="el-970zfluh"
            >
              Testimonials
            </h2>
            <p
              className="text-lg text-gray-600 max-w-3xl mx-auto"
              id="el-4d50syit"
            >
              Hear from farmers, rural entrepreneurs, and organizations who've
              transformed their operations with GeeCom.
            </p>
          </div>

          {/* Featured Testimonial */}
          {/* <div
            className="max-w-5xl mx-auto mb-20 bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl overflow-hidden shadow-sm"
            id="el-lskgdnep"
          >
            <div
              className="grid grid-cols-1 md:grid-cols-2"
              id="el-9uud1cv4"
              data-aos="fade-left"
            >
              <div
                className="p-8 md:p-12 flex flex-col justify-center"
                id="el-crh7jsdu"
              >
                <svg
                  className="h-10 w-10 text-blue-600 mb-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  id="el-3dnn7cv4"
                >
                  <path
                    d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"
                    id="el-c6w3k10r"
                  />
                </svg>

                <blockquote className="mb-6" id="el-ku8asy14">
                  <p
                    className="text-lg text-gray-700 italic leading-relaxed"
                    id="el-mxjoefvo"
                  >
                    "GeeCom India played a crucial role in digitizing our lab
                    testing process, making data management faster, more
                    accurate, and transparent. Their team understood our
                    operational needs and provided a user-friendly solution that
                    integrates smoothly with our workflow. It has helped improve
                    traceability, reduce paperwork, and save time – a real boost
                    for SOPA's efficiency."
                  </p>
                </blockquote>

                <div className="flex items-center" id="el-onwzt81i">
                  <div
                    className="flex-shrink-0 h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center mr-4"
                    id="el-979ywaoa"
                  >
                    <span className="text-blue-600 font-bold" id="el-qr6tzg1z">
                      SK
                    </span>
                  </div>
                  <div id="el-8qv8lo78">
                    <h4 className="font-bold text-gray-900" id="el-liuo8r47">
                      D. N. Pathak
                    </h4>
                    <p className="text-gray-600 text-sm" id="el-fmhgygf5">
                      Executive Director, SOPA
                    </p>
                  </div>
                </div>
              </div>

              <div className="relative" id="el-owwg2xyd">
                <img
                  src={PathakSirImage}
                  alt="Woman smiling with academic achievements"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src =
                      "https://placehold.co/600x800?text=Success+Story";
                    e.currentTarget.classList.add("object-contain", "p-4");
                  }}
                  className="w-full h-full object-cover"
                  width="5834"
                  height="3959"
                  id="el-w806232e"
                />
              </div>
            </div>
          </div> */}
        </div>
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 ml-8"
          data-aos="fade-up"
        >
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-sm p-8 border border-gray-100 hover:shadow-md transition-shadow duration-300"
            >
              <div className="flex items-center mb-6">
                <div className="flex-shrink-0 h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-blue-600 font-bold">
                    {testimonial.initials}
                  </span>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">
                    {testimonial.name}
                  </h4>
                  <p className="ttext-gray-600 text-sm">{testimonial.role}</p>
                </div>
              </div>

              <blockquote className="mb-4">
                <svg
                  className="h-5 w-5 text-blue-600 mb-2"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-
              10.609l.995 2.151c-2.432.917-3.995 
              3.638-3.995 5.849h4v10h-9.983zm-14.017 
              0v-7.391c0-5.704 3.748-9.57 
              9-10.609l.996 2.151c-2.433.917-3.996 
              3.638-3.996 5.849h3.983v10h-9.983z"
                  />
                </svg>
                <p className="text-gray-700 italic" id="el-ccb5e7pv">
                  "{testimonial.message}"
                </p>
              </blockquote>

              <div className="flex items-center">
                <StarRating count={testimonial.rating} />
                <span className="text-sm text-gray-500 ml-2">
                  {testimonial.date}
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-20 relative overflow-hidden" data-aos="fade-up">
          <h3 className="text-2xl font-bold text-gray-900 mb-10 text-center">
            More Success Stories
          </h3>

          <div
            className="relative w-full overflow-hidden group"
            data-aos="zoom-in"
          >
            <div
              className="flex gap-6 w-max animate-[scroll_30s_linear_infinite] group-hover:[animation-play-state:paused]"
              style={{
                animationName: "scroll",
                animationDuration: "30s",
                animationTimingFunction: "linear",
                animationIterationCount: "infinite",
              }}
            >
              {[...testimonialsdata, ...testimonialsdata].map(
                (testimonial, index) => (
                  <div
                    key={index}
                    onMouseEnter={handlePause}
                    onMouseLeave={handleResume}
                    onTouchStart={handlePause}
                    onTouchEnd={handleResume}
                    className="flex-shrink-0 w-80 p-6 bg-white rounded-xl shadow-sm border border-gray-100 hover:border-blue-500 hover:scale-105 transition-transform duration-300"
                  >
                    <div className="flex items-center mb-4">
                      <div className="h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                        <span className="text-blue-600 font-bold text-sm">
                          {testimonial.initials}
                        </span>
                      </div>
                      <div>
                        <h5 className="font-bold text-gray-900 text-sm">
                          {testimonial.name}
                        </h5>
                        <p className="text-gray-600 text-xs">
                          {testimonial.role}
                        </p>
                      </div>
                    </div>
                    <p className="text-gray-700 text-sm italic">
                      "{testimonial.message}"
                    </p>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
        <div className="mt-16 text-center">
          <button
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-300"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Watch Video Testimonials
          </button>
        </div>
        {/* Video Section */}
        {isModalOpen && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center px-4 sm:px-6 lg:px-8"
            role="dialog"
            aria-modal="true"
          >
            <div
              className="absolute inset-0 bg-black bg-opacity-70 transition-opacity"
              onClick={() => setIsModalOpen(false)}
            ></div>

            <div className="relative w-full max-w-5xl bg-white rounded-2xl shadow-2xl flex flex-col max-h-[90vh] overflow-hidden z-10">
              {/* Header */}
              <div className="flex items-center justify-between p-5 border-b border-gray-200">
                <h3 className="text-lg sm:text-xl font-bold text-gray-800">
                  Customer Success Stories
                </h3>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <svg
                    className="h-6 w-6"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              {/* Content Area with Scroll */}
              <div className="overflow-y-auto flex-1">
                {/* Video Section */}
                <div className="relative h-64 sm:h-80 bg-gray-100 flex items-center justify-center">
                  <img
                    src={`https://img.youtube.com/vi/${getYouTubeVideoId(
                      selectedVideo.videoUrl
                    )}/0.jpg`}
                    alt={selectedVideo.name}
                    className="w-full h-full object-cover opacity-80"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <button
                      onClick={() =>
                        window.open(selectedVideo.videoUrl, "_blank")
                      }
                      className="h-20 w-20 bg-white bg-opacity-80 rounded-full flex items-center justify-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="w-10 h-10 text-blue-600"
                      >
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </button>
                  </div>
                </div>

                {/* Testimonials Section */}
                <div className="px-5 py-4 sm:py-5">
                  <h4 className="font-medium text-gray-900 mb-3">
                    Featured Customer Stories:
                  </h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {testimonialsPopup.map((t, idx) => (
                      <div
                        key={idx}
                        onClick={() => setSelectedVideo(t)}
                        className={`cursor-pointer text-left p-3 rounded border ${
                          selectedVideo.name === t.name
                            ? "border-blue-400 bg-blue-50"
                            : "border-gray-200"
                        } hover:bg-gray-50 flex items-center transition-colors`}
                      >
                        <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center mr-3">
                          <span className="text-blue-600 font-bold text-xs">
                            {t.initials}
                          </span>
                        </div>
                        <div>
                          <p className="font-medium text-gray-900 text-sm">
                            {t.name}
                          </p>
                          <p className="text-gray-600 text-xs">{t.role}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default Testimonials;
